import { render, staticRenderFns } from "./PartnerCopyIframe.vue?vue&type=template&id=1d20ceb5&"
import script from "./PartnerCopyIframe.vue?vue&type=script&lang=ts&"
export * from "./PartnerCopyIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports